module.exports = __webpack_public_path__ + "img/image-right.4789016e.svg";